import { AccessorsMutatorsDecorator } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { Addon } from "./addon.model";

/**
 * @class AddonInterval
 * @property {number} id
 * @property {Addon} addon
 * @property {string} name
 */
export class AddonInterval extends TranslatableModel {
    
    /**
     * @type {string[]}
     */
    static get translatableAttributes() {
        
        return [ 'name' ];
    }
    
    /**
     * @param {Object|Addon} value
     * @returns {Addon}
     */
    setAddon(value) {
        
        return value instanceof Addon ? value : new Addon(value);
    }
    
    static get validationModel() {
        
        return {
            name: {
                label: 'INTERVAL_NAME_IN_ENGLISH',
                commonLabel: 'Interval name'
            },
            name_ar: {
                label: 'INTERVAL_NAME_IN_ARABIC',
                commonLabel: 'Interval name'
            },
            min_overlap: {
                label: 'MINIMUM_OVERLAP',
                messages: {
                    notGreaterThan: 'MIN_OVERLAP_CANNOT_BE_GREATER_THAN_MAX_OVERLAP'
                }
            },
            max_overlap: {
                label: 'MAXIMUM_OVERLAP',
                messages: {
                    notLessThan: 'MAX_OVERLAP_CANNOT_BE_LESS_THAN_MIN_OVERLAP'
                }
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...AddonInterval.translatableAttributesWithLanguageAliases, 'addon_id', 'addon', 'status', 'start_date', 'end_date', 'min_overlap', 'max_overlap', 'property_accommodation_types', 'created_at')(AddonInterval);


// WEBPACK FOOTER //
// ./src/pms-api/models/addon-interval.model.js